$(document).ready(function(){
	$('#off-canvas-menu').on('opened.zf.offCanvas', function(){
		$('#mobile-navigation-toggle').addClass('is-active');
	});
	$('#off-canvas-menu').on('close.zf.offCanvas', function(){
		$('#mobile-navigation-toggle').removeClass('is-active');
	});
});